import { Component } from '@angular/core';

@Component({
  selector: 'app-expired-invitation',
  templateUrl: 'expiredinvitation.component.html',
  styleUrls: ['expiredinvitation.component.css']
})
export class ExpiredInvitationComponent {}
